import React from 'react'
import { IonPage } from '@ionic/react'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import BarriersToCareContent from './BarriersToCare.component'

const BarriersToCare: React.FC = () => {
  return (
    <IonPage id='BarriersToCare'>
      <PCRHeader />
      <BarriersToCareContent />
    </IonPage>
  )
}

export default BarriersToCare
